import { render } from "./EditClaimView.vue?vue&type=template&id=c32fb1a4"
import script from "./EditClaimView.vue?vue&type=script&lang=js"
export * from "./EditClaimView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__